export default {
    parts: [
        'container',
        'content',
        'info',
        'name',
        'address',
        'hours',
        'ctas',
        'cta',
        'customClose'
    ],
    baseStyle: (props) => ({
        container: {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            backgroundColor: 'white',
        },
        content: {
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'space-between',
            gap: 4,
            p: 4,
            pb: 0
        },
        info: {
            marginBottom: 3
        },
        name: {
            textStyle: 'webH3',
            marginBottom: '14.5px'
        },
        address: {
            textStyle: 'bodySmRegular'
        },
        hours: {
            px: 4,
            mb: '19px',
            textStyle: 'bodyXsRegular'
        },
        ctas: {
            display: 'flex',
            flexWrap: 'no-wrap',
            gap: 2,
            p: {base: 4},
            borderTop: {base: '1px solid'},
            borderColor: {base: 'webTheme.strokeTertiary'},
        },
        cta: {
            width: '100%'
        }
    }),

    variants: {
        FindInStore: (props) => ({
            container: {
                paddingTop: '48px'
            },
            content: {
                position: 'relative'
            },
            customClose: {
                position: 'absolute',
                right: '0',
                top: '-40px',
                cursor: 'pointer'
            }
        })
    }
}
